import { createReducer } from 'redux-act';
import actions from '../actions/rolesActions';

const initialState = {
    getAllRolesPending: false,
    getAllRolesRes: null,
    getAllRolesError: null,

    addRolePending: false,
    addRoleRes: null,
    addRoleError: null,

    getAllRolesDataPending: false,
    getAllRolesDataRes: null,
    getAllRolesDataError: null,

    updateRolePending: false,
    updateRoleRes: null,
    updateRoleError: null,

    deleteRolePending: false,
    deleteRoleRes: null,
    deleteRoleError: null,

    assignRolePending: false,
    assignRoleRes: null,
    assignRoleError: null,

    getEmployeesByRolePending: false,
    getEmployeesByRoleRes: null,
    getEmployeesByRoleError: null,
}

/* Add Role Reducers */
const handleAddRoleRequest = state => {
    return {
        ...state,
        ...{
            addRolePending: true,
            addRoleRes: null,
            addRoleError: null,
        },
    };
};
const handleAddRoleSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addRolePending: false,
            addRoleRes: payload,
            addRoleError: null,
        },
    };
};
const handleAddRoleError = (state, payload) => ({
    ...state,
    ...{
        addRolePending: false,
        addRoleRes: null,
        addRoleError: payload,
    },
});

/* Get All Roles Reducers */
const handleGetAllRolesRequest = state => {
    return {
        ...state,
        ...{
            getAllRolesPending: true,
            getAllRolesRes: null,
            getAllRolesError: null,
        },
    };
};
const handleGetAllRolesSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAllRolesPending: false,
            getAllRolesRes: payload,
            getAllRolesError: null,
        },
    };
};
const handleGetAllRolesError = (state, payload) => ({
    ...state,
    ...{
        getAllRolesPending: false,
        getAllRolesRes: null,
        getAllRolesError: payload,
    },
});

/* Get All Roles Reducers */
const handleGetAllRolesDataRequest = state => {
    return {
        ...state,
        ...{
            getAllRolesDataPending: true,
            getAllRolesDataRes: null,
            getAllRolesDataError: null,
        },
    };
};
const handleGetAllRolesDataSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAllRolesDataPending: false,
            getAllRolesDataRes: payload,
            getAllRolesDataError: null,
        },
    };
};
const handleGetAllRolesDataError = (state, payload) => ({
    ...state,
    ...{
        getAllRolesDataPending: false,
        getAllRolesDataRes: null,
        getAllRolesDataError: payload,
    },
});

/* update Role Reducers */
const handleUpdateRoleRequest = state => {
    return {
        ...state,
        ...{
            updateRolePending: true,
            updateRoleRes: null,
            updateRoleError: null,
        },
    };
};
const handleUpdateRoleSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updateRolePending: false,
            updateRoleRes: payload,
            updateRoleError: null,
        },
    };
};
const handleUpdateRoleError = (state, payload) => ({
    ...state,
    ...{
        updateRolePending: false,
        updateRoleRes: null,
        updateRoleError: payload,
    },
});

/* Delete  Roles Reducers */
const handleDeleteRoleRequest = state => {
    return {
        ...state,
        ...{
            deleteRolePending: true,
            deleteRoleRes: null,
            deleteRoleError: null,
        },
    };
};
const handleDeleteRoleSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            deleteRolePending: false,
            deleteRoleRes: payload,
            deleteRoleError: null,
        },
    };
};
const handleDeleteRoleError = (state, payload) => ({
    ...state,
    ...{
        deleteRolePending: false,
        deleteRoleRes: null,
        deleteRoleError: payload,
    },
});

/* Assign Role Reducers */
const handleAssignRoleRequest = state => {
    return {
        ...state,
        ...{
            assignRolePending: true,
            assignRoleRes: null,
            assignRoleError: null,
        },
    };
};
const handleAssignRoleSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            assignRolePending: false,
            assignRoleRes: payload,
            assignRoleError: null,
        },
    };
};
const handleAssignRoleError = (state, payload) => ({
    ...state,
    ...{
        assignRolePending: false,
        assignRoleRes: null,
        assignRoleError: payload,
    },
});

/*Sub Task Status Reducers */
const handleGetEmployeesByRoleRequest = state1 => {
    return {
        ...state1,
        ...{
            getEmployeesByRolePending: true,
            getEmployeesByRoleRes: null,
            getEmployeesByRoleError: null,
        },
    };
};
const handleGetEmployeesByRoleSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getEmployeesByRolePending: false,
            getEmployeesByRoleRes: payload,
            getEmployeesByRoleError: null,
        },
    };
};
const handleGetEmployeesByRoleError = (state1, payload) => ({
    ...state1,
    ...{
        getEmployeesByRolePending: false,
        getEmployeesByRoleRes: null,
        getEmployeesByRoleError: payload,
    },
});

/* clear Role Store */
const handleClearRoleStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_ROLE_STORE':
            return {
                ...state,
                ...{
                    addRolePending: false,
                    addRoleRes: null,
                    addRoleError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_ROLE_STORE':
            return {
                ...state,
                ...{
                    updateRolePending: false,
                    updateRoleRes: null,
                    updateRoleError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_ROLE_STORE':
            return {
                ...state,
                ...{
                    deleteRolePending: false,
                    deleteRoleRes: null,
                    deleteRoleError: null,
                },
            };
        case 'HANDLE_CLEAR_ASSIGN_ROLE_STORE':
            return {
                ...state,
                ...{
                    assignRolePending: false,
                    assignRoleRes: null,
                    assignRoleError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {

        [actions.addRoleRequest]: handleAddRoleRequest,
        [actions.addRoleSuccess]: handleAddRoleSuccess,
        [actions.addRoleError]: handleAddRoleError,

        [actions.getAllRolesRequest]: handleGetAllRolesRequest,
        [actions.getAllRolesSuccess]: handleGetAllRolesSuccess,
        [actions.getAllRolesError]: handleGetAllRolesError,

        [actions.getAllRolesDataRequest]: handleGetAllRolesDataRequest,
        [actions.getAllRolesDataSuccess]: handleGetAllRolesDataSuccess,
        [actions.getAllRolesDataError]: handleGetAllRolesDataError,

        [actions.updateRoleRequest]: handleUpdateRoleRequest,
        [actions.updateRoleSuccess]: handleUpdateRoleSuccess,
        [actions.updateRoleError]: handleUpdateRoleError,

        [actions.deleteRoleRequest]: handleDeleteRoleRequest,
        [actions.deleteRoleSuccess]: handleDeleteRoleSuccess,
        [actions.deleteRoleError]: handleDeleteRoleError,

        [actions.assignRoleRequest]: handleAssignRoleRequest,
        [actions.assignRoleSuccess]: handleAssignRoleSuccess,
        [actions.assignRoleError]: handleAssignRoleError,

        [actions.getEmployeesByRoleRequest]: handleGetEmployeesByRoleRequest,
        [actions.getEmployeesByRoleSuccess]: handleGetEmployeesByRoleSuccess,
        [actions.getEmployeesByRoleError]: handleGetEmployeesByRoleError,

        [actions.handleClearRolesStore]: handleClearRoleStore
    },
    initialState
)